import React, {useEffect, useState} from 'react';
import {getStackIcons} from '../../../api/carrer';
import ThemeToggle from './ThemeToggle';
import styles from './NewHomePage.module.css';
import {usePortfolioTheme} from './usePortfolioTheme';

const careerEntries = [
    {
        id: 'objective-senior',
        name: 'Objective',
        color: '#764dcc',
        roles: [
            {
                role: 'Engenheiro de Software Sênior',
                date: 'Jul/2024 - Atual',
                tags: ['PHP', 'DDD', 'PHPUnit', 'React', 'Jest', 'Cypress', 'CI/CD', '3DS', 'Network Token', 'COF'],
                description: `- Consultoria ao EBANX
- Gateways de pagamento, 3DS, Network Token e COF
- PHP com DDD como metodologia de desenvolvimento
- Testes unitários com PHPUnit
- Frontend em React com testes usando Jest e Cypress
- Integração com CI/CD`,
            },
        ],
    },
    {
        id: '123milhas',
        name: '123milhas',
        color: '#37c9e9',
        roles: [
            {
                role: 'Desenvolvedor Backend Sênior',
                date: 'Out/2023 - Jul/2024',
                tags: ['Laravel', 'MySQL', 'PHPUnit', 'Pest', 'SQS', 'CI/CD', 'Kubernetes', 'DDD'],
                description: `- Desenvolvimento e manutenção de aplicação backend em Laravel + MySQL
- Integração com gateways de pagamento
- Definição de arquitetura e implementação de cultura de testes
- Testes unitários com PHPUnit e Pest
- Jobs de alto desempenho usando SQS
- Apoio a squads na API interna de pagamentos
- Integração com CI/CD e pipeline de deploy no Kubernetes`,
            },
            {
                role: 'Desenvolvedor Backend Pleno',
                date: 'Dez/2022 - Dez/2023',
                tags: [],
                description: '',
            },
        ],
    },
    {
        id: 'objective-mid-level',
        name: 'Objective',
        color: '#764dcc',
        roles: [
            {
                role: 'Desenvolvedor Backend Pleno',
                date: 'Mai/2022 - Dez/2022',
                tags: ['PHP', 'DDD', 'PHPUnit', 'React', 'Jest', 'Cypress', 'CI/CD'],
                description: `- Consultoria ao EBANX
- Gateways de pagamento
- Frontend: desenvolvimento e manutenção da Payment Page com React, testes com Jest e Cypress
- Backend em PHP com DDD e testes unitários com PHPUnit
- CI/CD`,
            },
        ],
    },
    {
        id: 'logcomex',
        name: 'Logcomex',
        color: '#37e97e',
        roles: [
            {
                role: 'Engenheiro de Software',
                date: 'Set/2021 - Mai/2022',
                tags: ['Vue', 'Nuxt.js', 'TypeScript', 'Laravel', 'PHP', 'PostgreSQL', 'RabbitMQ', 'Lumen', 'AWS Lambda', 'Python', 'SQS', 'SNS', 'Jest', 'PHPUnit', 'pytest'],
                description: `- Desenvolvimento e manutenção de sistemas com frontend em Vue + Nuxt.js e TypeScript
- Backend em Laravel + PHP com PostgreSQL
- Refatoração de monólito para arquitetura de microsserviços com RabbitMQ e Lumen
- Lambda functions na AWS com Python + Aurora PostgreSQL, conectadas a SQS e SNS
- Testes unitários no frontend com Jest
- Testes unitários em PHP com PHPUnit
- Testes unitários em Python com pytest`,
            },
            {
                role: 'Engenheiro de Software Jr II',
                date: 'Jul/2021 - Out/2021',
                tags: [],
                description: '',
            },
            {
                role: 'Engenheiro de Software Jr',
                date: 'Fev/2021 - Out/2021',
                tags: [],
                description: '',
            },
        ],
    },
    {
        id: 'teknisa',
        name: 'Teknisa',
        color: '#37c9e9',
        roles: [
            {
                role: 'Estagiário de Programação',
                date: 'Set/2020 - Fev/2021',
                tags: ['PHP', 'JavaScript', 'TypeScript', 'JSON', 'Vue', 'Oracle SQL'],
                description: `- Implantação de novas funcionalidades
- Desenvolvimento de software
- PHP, JavaScript, TypeScript, JSON e Vue
- Banco de dados com Oracle SQL Developer`,
            },
        ],
    },
];

const careerEntriesEnglish = [
    {
        roles: [
            {
                role: 'Senior Software Engineer',
                date: 'Jul 2024 - Present',
                description: `- Consulting for EBANX
- Payment gateways, 3DS, Network Token and COF
- PHP with DDD as the development methodology
- Unit tests with PHPUnit
- React frontend with Jest and Cypress tests
- CI/CD integration`,
            },
        ],
    },
    {
        roles: [
            {
                role: 'Senior Backend Developer',
                date: 'Oct 2023 - Jul 2024',
                description: `- Backend application development and maintenance using Laravel + MySQL
- Payment gateway integrations
- Architecture definition and implementation of a unit testing culture
- Unit tests with PHPUnit and Pest
- High-performance jobs using SQS
- Support for squads on the internal payments API
- CI/CD integration and deployment pipeline on Kubernetes`,
            },
            {
                role: 'Mid-level Backend Developer',
                date: 'Dec 2022 - Dec 2023',
                description: '',
            },
        ],
    },
    {
        roles: [
            {
                role: 'Mid-level Backend Developer',
                date: 'May 2022 - Dec 2022',
                description: `- Consulting for EBANX
- Payment gateways
- Frontend: development and maintenance of the Payment Page with React, tests with Jest and Cypress
- PHP backend with DDD and unit tests with PHPUnit
- CI/CD`,
            },
        ],
    },
    {
        roles: [
            {
                role: 'Software Engineer',
                date: 'Sep 2021 - May 2022',
                description: `- Development and maintenance of systems with Vue, Nuxt.js and TypeScript frontend
- Laravel + PHP backend with PostgreSQL
- Refactoring a monolith into a microservices architecture with RabbitMQ and Lumen
- AWS Lambda functions with Python + Aurora PostgreSQL, connected to SQS and SNS
- Frontend unit tests using Jest
- PHP unit tests using PHPUnit
- Python unit tests using pytest`,
            },
            {
                role: 'Software Engineer Jr II',
                date: 'Jul 2021 - Oct 2021',
                description: '',
            },
            {
                role: 'Software Engineer Jr',
                date: 'Feb 2021 - Oct 2021',
                description: '',
            },
        ],
    },
    {
        roles: [
            {
                role: 'Programming Intern',
                date: 'Sep 2020 - Feb 2021',
                description: `- Implementation of new features
- Software development
- PHP, JavaScript, TypeScript, JSON and Vue
- Oracle SQL Developer database`,
            },
        ],
    },
];

const dboIdleSlides = [
    {
        src: '/projects/dbo-idle/carousel-1.webp',
        srcSet: '/projects/dbo-idle/carousel-1-480.webp 480w, /projects/dbo-idle/carousel-1-800.webp 800w, /projects/dbo-idle/carousel-1.webp 1849w',
        altPt: 'Página inicial do Dbo Idle com personagens de Dragon Ball em um cenário inspirado em Tibia',
        altEn: 'Dbo Idle home page with Dragon Ball characters in a Tibia-inspired setting',
    },
    {
        src: '/projects/dbo-idle/carousel-2.webp',
        srcSet: '/projects/dbo-idle/carousel-2-480.webp 480w, /projects/dbo-idle/carousel-2-800.webp 800w, /projects/dbo-idle/carousel-2.webp 1849w',
        altPt: 'Interface do jogo Dbo Idle exibindo o mapa, o personagem e os painéis de jogo',
        altEn: 'Dbo Idle game interface showing the map, character and game panels',
    },
];

const heroImagePriority: Record<string, string> = {fetchPriority: 'high'};
const projectImageSizes = '(max-width: 760px) calc(100vw - 36px), (max-width: 1280px) 58vw, 760px';

type Language = 'pt' | 'en';

const pageCopy = {
    pt: {
        languageLabel: 'Selecionar idioma',
        themeToDark: 'Ativar tema escuro',
        themeToLight: 'Ativar tema claro',
        skipLink: 'Pular para o conteúdo',
        mainNavigation: 'Navegação principal',
        mobileNavigation: 'Navegação mobile',
        menuOpen: 'Abrir menu',
        menuClose: 'Fechar menu',
        navProjects: 'Projetos',
        navAbout: 'Sobre mim',
        navCareer: 'Carreira',
        navTechnologies: 'Tecnologias',
        navContact: 'Contato',
        heroGreeting: 'Hello World',
        heroRole: 'Engenheiro de Software Sênior',
        heroLinkedIn: 'LinkedIn',
        heroContact: 'Contato',
        heroImageAlt: 'Ilustração de Gabriel trabalhando no computador',
        scroll: 'Role para conhecer',
        projectsKicker: '02 / PROJETOS',
        projectsTitle: 'Projetos',
        projectsIntro: 'Jogos construídos a partir de universos que fizeram parte da minha trajetória com tecnologia e desenvolvimento.',
        dboKind: '01 / JOGO PARA NAVEGADOR',
        dboDescription: 'Um jogo Tibia para navegador inspirado em Dragon Ball.',
        release: 'Previsão de lançamento',
        visitDbo: 'Acessar dboidle.com',
        previousDbo: 'Exibir imagem anterior do Dbo Idle',
        nextDbo: 'Exibir próxima imagem do Dbo Idle',
        selectDboImage: 'Selecionar imagem',
        dboCarousel: 'Imagens do Dbo Idle',
        carouselRole: 'carrossel',
        showDboImage: 'Exibir imagem',
        pokemonKind: '02 / JOGO MULTIPLATAFORMA',
        developing: 'Em desenvolvimento',
        pokemonDescription: 'Um jogo Tibia para computador e Android inspirado em Pokémon. Está em desenvolvimento, com lançamento previsto para 1º de fevereiro de 2027.',
        pokemonAlt: 'Página inicial do Pokémon Ward, jogo inspirado em Pokémon e Tibia',
        visitPokemon: 'Acessar pokeward.com',
        aboutKicker: '03 / SOBRE MIM',
        aboutTitle: 'Carreira e experiência',
        aboutFirst: 'Sou formado em Análise e Desenvolvimento de Sistemas e atuo como engenheiro de software, com especialidade no desenvolvimento de sistemas backend.',
        aboutSecond: 'Tenho experiência com PHP, Laravel, Lumen, Symfony, Node.js, JavaScript, TypeScript, React, MySQL e PostgreSQL, além de serviços AWS e mensageria com RabbitMQ. No dia a dia, aplico TDD e DDD com foco em qualidade de código.',
        professionalHistory: 'Histórico profissional',
        experiences: 'experiências',
        technologies: 'Tecnologias',
        stack: 'Stack',
        showMore: 'Ver mais',
        technologiesUsed: 'Tecnologias utilizadas',
        contactKicker: '04 / CONTATO',
        contactTitle: 'Contato',
        contactIntro: 'Canais profissionais para acompanhar meu trabalho ou entrar em contato diretamente.',
        linkedinLabel: 'Perfil profissional',
        githubLabel: 'Código e projetos',
        emailLabel: 'E-mail',
        openProfile: 'Abrir perfil',
        sendEmail: 'Enviar e-mail',
        backToTop: 'Voltar ao início',
        credentialsHeading: 'Formação e idioma',
        credentialsMeta: 'Perfil',
        credentialsEducationLabel: 'Formação acadêmica',
        credentialsDegree: 'Tecnólogo em Análise e Desenvolvimento de Sistemas',
        credentialsInstitution: 'Faculdade Pitágoras',
        credentialsPeriod: 'Jan/2020 - Jul/2022',
        credentialsLanguageLabel: 'Idioma',
        credentialsLanguage: 'Inglês intermediário',
        credentialsLevel: 'B1 · EF SET',
    },
    en: {
        languageLabel: 'Select language',
        themeToDark: 'Switch to dark theme',
        themeToLight: 'Switch to light theme',
        skipLink: 'Skip to content',
        mainNavigation: 'Main navigation',
        mobileNavigation: 'Mobile navigation',
        menuOpen: 'Open menu',
        menuClose: 'Close menu',
        navProjects: 'Projects',
        navAbout: 'About me',
        navCareer: 'Career',
        navTechnologies: 'Technologies',
        navContact: 'Contact',
        heroGreeting: 'Hello World',
        heroRole: 'Senior Software Engineer',
        heroLinkedIn: 'LinkedIn',
        heroContact: 'Contact',
        heroImageAlt: 'Illustration of Gabriel working at a computer',
        scroll: 'Scroll to explore',
        projectsKicker: '02 / PROJECTS',
        projectsTitle: 'Projects',
        projectsIntro: 'Games built around fictional universes that have been part of my journey with technology and software development.',
        dboKind: '01 / BROWSER GAME',
        dboDescription: 'A browser-based Tibia game inspired by Dragon Ball.',
        release: 'Expected release',
        visitDbo: 'Visit dboidle.com',
        previousDbo: 'Show previous Dbo Idle image',
        nextDbo: 'Show next Dbo Idle image',
        selectDboImage: 'Select image',
        dboCarousel: 'Dbo Idle images',
        carouselRole: 'carousel',
        showDboImage: 'Show image',
        pokemonKind: '02 / MULTIPLATFORM GAME',
        developing: 'In development',
        pokemonDescription: 'A Tibia game for desktop and Android inspired by Pokémon. It is currently in development, with release planned for February 1, 2027.',
        pokemonAlt: 'Pokémon Ward home page, a game inspired by Pokémon and Tibia',
        visitPokemon: 'Visit pokeward.com',
        aboutKicker: '03 / ABOUT ME',
        aboutTitle: 'Career and experience',
        aboutFirst: 'I hold a degree in Systems Analysis and Development and work as a software engineer specializing in backend systems.',
        aboutSecond: 'I have experience with PHP, Laravel, Lumen, Symfony, Node.js, JavaScript, TypeScript, React, MySQL and PostgreSQL, as well as AWS services and messaging with RabbitMQ. I apply TDD and DDD in my daily work, with a strong focus on code quality.',
        professionalHistory: 'Professional history',
        experiences: 'experiences',
        technologies: 'Technologies',
        stack: 'Stack',
        showMore: 'See more',
        technologiesUsed: 'Technologies used',
        contactKicker: '04 / CONTACT',
        contactTitle: 'Contact',
        contactIntro: 'Professional channels where you can follow my work or contact me directly.',
        linkedinLabel: 'Professional profile',
        githubLabel: 'Code and projects',
        emailLabel: 'Email',
        openProfile: 'Open profile',
        sendEmail: 'Send email',
        backToTop: 'Back to top',
        credentialsHeading: 'Education and language',
        credentialsMeta: 'Profile',
        credentialsEducationLabel: 'Academic education',
        credentialsDegree: 'Technology degree in Systems Analysis and Development',
        credentialsInstitution: 'Faculdade Pitágoras',
        credentialsPeriod: 'Jan 2020 - Jul 2022',
        credentialsLanguageLabel: 'Language',
        credentialsLanguage: 'Intermediate English',
        credentialsLevel: 'B1 · EF SET',
    },
} as const;

function NewHomePage() {
    const stackGroups = getStackIcons();
    const {theme, toggleTheme} = usePortfolioTheme();
    const [activeDboSlide, setActiveDboSlide] = useState(0);
    const [carouselPaused, setCarouselPaused] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [language, setLanguage] = useState<Language>(() => {
        const savedLanguage = window.localStorage.getItem('portfolioLanguage')
            || window.localStorage.getItem('i18nextLng');
        const preferredLanguage = savedLanguage || window.navigator.language;
        return preferredLanguage?.toLowerCase().startsWith('en') ? 'en' : 'pt';
    });
    const copy = pageCopy[language];
    const localizedCareerEntries = careerEntries.map((entry, index) => ({
        ...entry,
        roles: entry.roles.map((role, roleIndex) => language === 'en'
            ? {...role, ...careerEntriesEnglish[index].roles[roleIndex]}
            : role,
        ),
    }));
    const navigationItems = [
        {href: '#projetos', label: copy.navProjects},
        {href: '#sobre', label: copy.navAbout},
        {href: '#carreira', label: copy.navCareer},
        {href: '#tecnologias', label: copy.navTechnologies},
        {href: '#contato', label: copy.navContact},
    ];

    useEffect(() => {
        const previousTitle = document.title;
        const previousLanguage = document.documentElement.lang;
        document.title = language === 'pt'
            ? 'Gabriel Lima | Engenheiro de Software Sênior'
            : 'Gabriel Lima | Senior Software Engineer';
        document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'en';

        return () => {
            document.title = previousTitle;
            document.documentElement.lang = previousLanguage;
        };
    }, [language]);

    useEffect(() => {
        if (!mobileMenuOpen) return;

        const closeMenuOnEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') setMobileMenuOpen(false);
        };

        window.addEventListener('keydown', closeMenuOnEscape);
        return () => window.removeEventListener('keydown', closeMenuOnEscape);
    }, [mobileMenuOpen]);

    useEffect(() => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (carouselPaused || reducedMotion) return;

        const interval = window.setInterval(() => {
            setActiveDboSlide((currentSlide) => (currentSlide + 1) % dboIdleSlides.length);
        }, 4500);

        return () => window.clearInterval(interval);
    }, [carouselPaused]);

    function changeDboSlide(direction: number) {
        setActiveDboSlide((currentSlide) => (
            currentSlide + direction + dboIdleSlides.length
        ) % dboIdleSlides.length);
    }

    function changeLanguage(nextLanguage: Language) {
        setLanguage(nextLanguage);
        window.localStorage.setItem('portfolioLanguage', nextLanguage);
        window.localStorage.setItem('i18nextLng', nextLanguage === 'pt' ? 'pt-BR' : 'en-US');
    }

    return (
        <div className={styles.page} id="inicio" data-theme={theme}>
            <a className={styles.skipLink} href="#conteudo">
                {copy.skipLink}
            </a>

            <header className={styles.header}>
                <div className={styles.headerContent}>
                    <a className={styles.logo} href="#inicio">
                        &lt;Gabriel<span>Dev</span> /&gt;
                    </a>

                    <nav className={styles.navigation} aria-label={copy.mainNavigation}>
                        {navigationItems.map((item) => (
                            <a href={item.href} key={item.href}>{item.label}</a>
                        ))}
                    </nav>

                    <div className={styles.headerControls}>
                        <div className={styles.languageSwitcher} role="group" aria-label={copy.languageLabel}>
                            <button
                                className={language === 'pt' ? styles.activeLanguage : ''}
                                type="button"
                                onClick={() => changeLanguage('pt')}
                                aria-pressed={language === 'pt'}
                            >
                                PT
                            </button>
                            <span aria-hidden="true">/</span>
                            <button
                                className={language === 'en' ? styles.activeLanguage : ''}
                                type="button"
                                onClick={() => changeLanguage('en')}
                                aria-pressed={language === 'en'}
                            >
                                EN
                            </button>
                        </div>

                        <ThemeToggle
                            theme={theme}
                            onToggle={toggleTheme}
                            label={theme === 'light' ? copy.themeToDark : copy.themeToLight}
                        />

                        <button
                            className={styles.menuToggle}
                            type="button"
                            aria-expanded={mobileMenuOpen}
                            aria-controls="mobile-navigation"
                            aria-label={mobileMenuOpen ? copy.menuClose : copy.menuOpen}
                            onClick={() => setMobileMenuOpen((isOpen) => !isOpen)}
                        >
                            <span/>
                            <span/>
                            <span/>
                        </button>
                    </div>
                </div>

                {mobileMenuOpen && (
                    <nav className={styles.mobileMenu} id="mobile-navigation" aria-label={copy.mobileNavigation}>
                        {navigationItems.map((item, index) => (
                            <a href={item.href} onClick={() => setMobileMenuOpen(false)} key={item.href}>
                                <span>0{index + 1}</span> {item.label}
                            </a>
                        ))}
                    </nav>
                )}
            </header>

            <main id="conteudo">
                <section className={styles.hero} aria-labelledby="hero-title">
                    <div className={styles.heroContent}>
                        <div className={styles.heroText}>
                            <p className={styles.hello}>
                                <span>01</span> {copy.heroGreeting}
                            </p>

                            <h1 id="hero-title">
                                I AM<br/>
                                <strong>GABRIEL LIMA</strong>
                            </h1>

                            <p className={styles.role}>{copy.heroRole}</p>

                            <div className={styles.heroActions}>
                                <a
                                    className={styles.primaryButton}
                                    href="https://www.linkedin.com/in/gabriel-ward/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {copy.heroLinkedIn}
                                </a>
                                <a className={styles.secondaryButton} href="#contato">
                                    {copy.heroContact}
                                </a>
                            </div>
                        </div>

                        <div className={styles.heroVisual}>
                            <span className={styles.codeDecoration} aria-hidden="true">{'{ }'}</span>
                            <div className={styles.imageFrame}>
                                <img
                                    src="/wellcomeIcon.svg"
                                    alt={copy.heroImageAlt}
                                    width="544"
                                    height="528"
                                    loading="eager"
                                    decoding="async"
                                    {...heroImagePriority}
                                />
                            </div>
                            <p aria-hidden="true">developer.profile.tsx</p>
                        </div>
                    </div>

                    <a className={styles.scrollHint} href="#projetos">
                        <span>{copy.scroll}</span>
                        <i aria-hidden="true">↓</i>
                    </a>
                </section>

                <section className={styles.projectsSection} id="projetos" aria-labelledby="projects-title">
                    <div className={styles.projectsIntro}>
                        <p className={styles.sectionNumber}>{copy.projectsKicker}</p>
                        <h2 id="projects-title">{copy.projectsTitle}</h2>
                        <p>{copy.projectsIntro}</p>
                    </div>

                    <div className={styles.projectsList}>
                        <article className={styles.project}>
                            <div
                                className={styles.projectMedia}
                                role="region"
                                aria-roledescription={copy.carouselRole}
                                aria-label={copy.dboCarousel}
                                onMouseEnter={() => setCarouselPaused(true)}
                                onMouseLeave={() => setCarouselPaused(false)}
                                onFocusCapture={() => setCarouselPaused(true)}
                                onBlurCapture={() => setCarouselPaused(false)}
                            >
                                <div className={styles.carouselSlides}>
                                    {dboIdleSlides.map((slide, index) => (
                                        <img
                                            className={index === activeDboSlide ? styles.activeSlide : ''}
                                            src={slide.src}
                                            srcSet={slide.srcSet}
                                            sizes={projectImageSizes}
                                            alt={index === activeDboSlide
                                                ? (language === 'pt' ? slide.altPt : slide.altEn)
                                                : ''}
                                            width="1849"
                                            height="931"
                                            loading="lazy"
                                            decoding="async"
                                            aria-hidden={index !== activeDboSlide}
                                            key={slide.src}
                                        />
                                    ))}
                                </div>

                                <div className={styles.carouselControls}>
                                    <button
                                        type="button"
                                        onClick={() => changeDboSlide(-1)}
                                        aria-label={copy.previousDbo}
                                    >
                                        ←
                                    </button>

                                    <div className={styles.carouselDots} aria-label={copy.selectDboImage}>
                                        {dboIdleSlides.map((slide, index) => (
                                            <button
                                                className={index === activeDboSlide ? styles.activeDot : ''}
                                                type="button"
                                                onClick={() => setActiveDboSlide(index)}
                                                aria-label={`${copy.showDboImage} ${index + 1} — Dbo Idle`}
                                                aria-current={index === activeDboSlide}
                                                key={slide.src}
                                            />
                                        ))}
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => changeDboSlide(1)}
                                        aria-label={copy.nextDbo}
                                    >
                                        →
                                    </button>
                                </div>
                            </div>

                            <div className={styles.projectContent}>
                                <p className={styles.projectIndex}>{copy.dboKind}</p>
                                <h3>Dbo Idle</h3>
                                <p className={styles.projectDescription}>{copy.dboDescription}</p>
                                <p className={styles.releaseDate}>
                                    {copy.release} <strong>15.08.2026</strong>
                                </p>
                                <a
                                    className={styles.projectLink}
                                    href="https://dboidle.com"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {copy.visitDbo} <span aria-hidden="true">↗</span>
                                </a>
                            </div>
                        </article>

                        <article className={`${styles.project} ${styles.projectReversed}`}>
                            <div className={styles.projectMedia}>
                                <img
                                    className={styles.staticProjectImage}
                                    src="/projects/pokemon-ward/preview-1.webp"
                                    srcSet="/projects/pokemon-ward/preview-1-480.webp 480w, /projects/pokemon-ward/preview-1-800.webp 800w, /projects/pokemon-ward/preview-1.webp 1849w"
                                    sizes={projectImageSizes}
                                    alt={copy.pokemonAlt}
                                    width="1849"
                                    height="931"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>

                            <div className={styles.projectContent}>
                                <div className={styles.projectMeta}>
                                    <p className={styles.projectIndex}>{copy.pokemonKind}</p>
                                    <span>{copy.developing}</span>
                                </div>
                                <h3>Pokémon Ward</h3>
                                <p className={styles.projectDescription}>{copy.pokemonDescription}</p>
                                <p className={styles.releaseDate}>
                                    {copy.release} <strong>01.02.2027</strong>
                                </p>
                                <a
                                    className={styles.projectLink}
                                    href="https://pokeward.com/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {copy.visitPokemon} <span aria-hidden="true">↗</span>
                                </a>
                            </div>
                        </article>
                    </div>
                </section>

                <section className={styles.careerSection} id="sobre">
                    <div className={styles.sectionIntro}>
                        <p className={styles.sectionNumber}>{copy.aboutKicker}</p>
                        <h2>{copy.aboutTitle}</h2>
                        <div className={styles.aboutText}>
                            <p>{copy.aboutFirst}</p>
                            <p>{copy.aboutSecond}</p>
                        </div>
                    </div>

                    <div className={styles.careerLayout} id="carreira">
                        <div className={styles.timelineColumn}>
                            <div className={styles.subsectionHeading}>
                                <span>{copy.professionalHistory}</span>
                                <span>{localizedCareerEntries.length} {copy.experiences}</span>
                            </div>

                            <div className={styles.timeline}>
                                {localizedCareerEntries.map((entry) => (
                                    <article className={styles.experience} key={entry.id}>
                                        <span
                                            className={styles.timelineDot}
                                            style={{'--accent': entry.color} as React.CSSProperties}
                                            aria-hidden="true"
                                        />
                                        <div className={styles.experienceCard}>
                                            <span className={styles.company}>{entry.name}</span>
                                            {entry.roles.map((role) => (
                                                <div className={styles.roleEntry} key={`${role.role}-${role.date}`}>
                                                    <div className={styles.roleHeading}>
                                                        <h3>{role.role}</h3>
                                                        <time>{role.date}</time>
                                                    </div>
                                                    {role.tags.length > 0 && (
                                                        <div className={styles.tags} aria-label={copy.technologiesUsed}>
                                                            {role.tags.map((tag) => <span key={tag}>{tag}</span>)}
                                                        </div>
                                                    )}
                                                    {role.description && (
                                                        <details className={styles.experienceDetails}>
                                                            <summary>{copy.showMore} <span aria-hidden="true">＋</span></summary>
                                                            <p>{role.description}</p>
                                                        </details>
                                                    )}
                                                </div>
                                            ))}
                                            <i
                                                className={styles.cardAccent}
                                                style={{'--accent': entry.color} as React.CSSProperties}
                                                aria-hidden="true"
                                            />
                                        </div>
                                    </article>
                                ))}
                            </div>
                        </div>

                        <aside className={styles.stackColumn}>
                            <section className={styles.credentialsBlock} aria-labelledby="credentials-title">
                                <div className={styles.credentialsHeading}>
                                    <h3 id="credentials-title">{copy.credentialsHeading}</h3>
                                    <span>{copy.credentialsMeta}</span>
                                </div>
                                <div className={styles.credentialsGrid}>
                                    <div className={styles.credentialsItem}>
                                        <span className={styles.credentialsLabel}>{copy.credentialsEducationLabel}</span>
                                        <strong>{copy.credentialsDegree}</strong>
                                        <span>{copy.credentialsInstitution}</span>
                                        <time>{copy.credentialsPeriod}</time>
                                    </div>
                                    <div className={styles.credentialsItem}>
                                        <span className={styles.credentialsLabel}>{copy.credentialsLanguageLabel}</span>
                                        <strong>{copy.credentialsLanguage}</strong>
                                        <span>{copy.credentialsLevel}</span>
                                    </div>
                                </div>
                            </section>

                            <div className={styles.technologiesBlock} id="tecnologias">
                                <div className={styles.subsectionHeading}>
                                    <span>{copy.technologies}</span>
                                    <span>{copy.stack}</span>
                                </div>

                                <div className={styles.stackGroups}>
                                    {stackGroups.map((group) => (
                                        <section className={styles.stackGroup} key={group.name}>
                                            <div className={styles.stackHeading}>
                                                <img src={`/${group.iconUrl}`} alt=""/>
                                                <h3>{group.name}</h3>
                                            </div>
                                            <div className={styles.stackIcons}>
                                                {group.stackIcons.map((icon) => (
                                                    <div className={styles.stackIcon} key={icon.name} title={icon.name}>
                                                        <img src={`/${icon.iconUrl.replace(/^\.\//, '')}`} alt={icon.name}/>
                                                        <span>{icon.name.replace('_icon', '')}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </section>
                                    ))}
                                </div>
                            </div>
                        </aside>
                    </div>
                </section>

                <section className={styles.contactSection} id="contato" aria-labelledby="contact-title">
                    <div className={styles.contactIntro}>
                        <p className={styles.sectionNumber}>{copy.contactKicker}</p>
                        <h2 id="contact-title">{copy.contactTitle}</h2>
                        <p>{copy.contactIntro}</p>
                    </div>

                    <div className={styles.contactLinks}>
                        <a
                            href="https://www.linkedin.com/in/gabriel-ward/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <span className={styles.contactIcon} aria-hidden="true">in</span>
                            <span className={styles.contactDetails}>
                                <small>{copy.linkedinLabel}</small>
                                <strong>gabriel-ward</strong>
                            </span>
                            <span className={styles.contactAction}>{copy.openProfile} ↗</span>
                        </a>

                        <a href="https://github.com/n4m-ward" target="_blank" rel="noreferrer">
                            <span className={styles.contactIcon} aria-hidden="true">{'{ }'}</span>
                            <span className={styles.contactDetails}>
                                <small>{copy.githubLabel}</small>
                                <strong>n4m-ward</strong>
                            </span>
                            <span className={styles.contactAction}>{copy.openProfile} ↗</span>
                        </a>

                        <a href="mailto:contato@gabrieldev.co">
                            <span className={styles.contactIcon} aria-hidden="true">@</span>
                            <span className={styles.contactDetails}>
                                <small>{copy.emailLabel}</small>
                                <strong>contato@gabrieldev.co</strong>
                            </span>
                            <span className={styles.contactAction}>{copy.sendEmail} →</span>
                        </a>
                    </div>
                </section>
            </main>

            <footer className={styles.footer}>
                <div>
                    <a className={styles.footerLogo} href="#inicio">&lt;GabrielDev /&gt;</a>
                    <p>{copy.heroRole}</p>
                </div>
                <a href="#inicio">{copy.backToTop} <span aria-hidden="true">↑</span></a>
            </footer>
        </div>
    );
}

export default NewHomePage;
